import { NgModule } from '@angular/core'

import { ImageModalComponent } from './image-modal.component'
import { CmsComponentsBaseModule } from '../../cms-components-base.module'
import { LazyLoadImageModule } from 'ng-lazyload-image'
import { PictureModule } from '../picture/picture.module'

@NgModule({
  declarations: [
    ImageModalComponent
  ],
  imports: [
    CmsComponentsBaseModule,
    LazyLoadImageModule,
    PictureModule
  ],
  exports: [
    ImageModalComponent
  ]
})
export class ImageModalModule {
}

export interface ModalImage {
  altText: string;
  title: string;
  mime: string;
  xl: string;
  xl2x: string;
  lg: string;
  lg2x: string;
  md: string;
  md2x: string;
  sm: string;
  sm2x: string;
  xs: string;
  xs2x: string;
}
